import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Exchange code for session
        const { data, error } = await supabase.auth.exchangeCodeForSession(location.hash);
        if (error) throw error;
        navigate('/generator', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/auth?mode=signin&error=callback_failed', { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate, location]);

  return ( 
    <div className="min-h-screen bg-volt-deep-blue flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-volt-blue border-t-transparent mb-4" />
        <p className="text-white">Completing authentication...</p>
      </div>
    </div>
  );
}